import React from 'react';
import {useSelector} from 'react-redux';

import ArticlePageLayout from '../../../components/DataDisplay/ArticlePageLayout';
import {IconLock} from '../../../components/Icons';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {hideModalAction} from '../../../state/ducks/modal';
import {selectIsMonoDevice} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';

const DeviceLockedPopup = (props) => {
    const localizedStrings = getLocalizedStrings();
    const {modalType, dispatch} = props;
    const isMonoDevice = useSelector(selectIsMonoDevice);
    const hidePopup = () => dispatch(hideModalAction(modalType));
    const titleKey = isMonoDevice
        ? localizationKeys.DEVICE_SETTING_DEVICE_LOCKED_POPUP_TITLE
        : localizationKeys.DEVICE_SETTING_HOLDER_LOCKED_POPUP_TITLE;
    const descriptionKey = isMonoDevice
        ? localizationKeys.DEVICE_SETTING_DEVICE_LOCKED_POPUP_MESSAGE
        : localizationKeys.DEVICE_SETTING_HOLDER_LOCKED_POPUP_MESSAGE;

    return (
        <PopupFullPage
            contentLabel={localizedStrings[titleKey]}
            closeButtonAriaLabel={localizedStrings[localizationKeys.CLOSE_NOTIFICATION_ARIA_LABEL]}
            closeButtonTestId={elementsTesIds.DEVICE_SETTINGS_BTN_CLOSE}
            isCloseVisible
            onClose={hidePopup}
        >
            <ArticlePageLayout
                containerClassName='pt-20'
                icon={<IconLock />}
                titleKey={titleKey}
                descriptionKey={descriptionKey}
                buttonSecondary={{
                    onClick: hidePopup,
                    textKey: localizationKeys.DEVICE_SETTING_DEVICE_LOCKED_POPUP_RETURN_BUTTON,
                    testId: elementsTesIds.LOCK_BTN_RETURN_TO_SETTINGS,
                }}
            />
        </PopupFullPage>
    );
};

export default DeviceLockedPopup;
